const TOKEN_KEY = "accessToken";
let memToken = "";

try {
    memToken = sessionStorage.getItem(TOKEN_KEY) || "";
} catch {

}

function parseJwtPayload(token) {
    try {
        const part = token.split(".")[1];
        if (!part) return null;

        let base64 = part.replace(/-/g, "+").replace(/_/g, "/");
        base64 += "=".repeat((4 - (base64.length % 4)) % 4);
        const json = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );

        return JSON.parse(json);
    } catch {
        return null;
    }
}

export function isAccessTokenExpired(token = memToken) {
    if (!token) return true;

    const payload = parseJwtPayload(token);
    if (!payload?.exp) return true;

    const nowSeconds = Math.floor(Date.now() / 1000);

    return payload.exp <= nowSeconds + 30;
}

export function setAccessToken(token) {
    memToken = token || "";

    try {
        if (token) {
            sessionStorage.setItem(TOKEN_KEY, token);
        } else {
            sessionStorage.removeItem(TOKEN_KEY);
        }
    } catch {
    
    }
}

export function getAccessToken() {
    if (!memToken) return "";

    if (isAccessTokenExpired(memToken)) {
        clearAccessToken(false);
        return "";
    }

    return memToken;
}

export function clearAccessToken(broadcast = true) {
    setAccessToken("");

    try {
        const toDel = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const k = sessionStorage.key(i);
            if (k && k.startsWith("obrazecZadeve:")) toDel.push(k);
        }
        toDel.forEach((k) => sessionStorage.removeItem(k));
    } catch {
       
    }

    if (broadcast) {
        try {
            localStorage.setItem("auth:logout", String(Date.now()));
        } catch {
           
        }
    }
}

const API_BASE = process.env.REACT_APP_API_BASE || "";

export async function apiFetch(path, options = {}, { autoRedirectOn401 = true } = {}) {
    const url = path.startsWith("http") ? path : `${API_BASE}${path}`;
    const headers = { Accept: "application/json", ...(options.headers || {}) };

    const token = getAccessToken();
    if (token) headers.Authorization = `Bearer ${token}`;

    const init = { ...options, headers };

    if (init.body && typeof init.body === "object" && !(init.body instanceof FormData)) {
        init.headers["Content-Type"] = "application/json";
        init.body = JSON.stringify(init.body);
    }

    const res = await fetch(url, init);

    if (res.status === 401 && autoRedirectOn401) {
        clearAccessToken(true);

        if (window.location.pathname !== "/vpis") {
            window.location.replace("/vpis");
        }
    }

    return res;
}

try {
    window.addEventListener("storage", (e) => {
        if (e.key === "auth:logout") {
            setAccessToken("");

            if (window.location.pathname !== "/vpis") {
                window.location.replace("/vpis");
            }
        }
    });
} catch {
    
}